<template>
    <div class="courtyards-section" v-if="courtyardsArr != null" id="menu-link-courtyards">
        <div class="container">
            <sectionTitle :options="[{ title : courtyardsArr.courtyards_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: courtyardsArr.courtyards_quote_img, title : courtyardsArr.courtyards_quote_title, desc: courtyardsArr.courtyards_quote_desc}]"></sectionBaner>
            <sectionDescColumn :options="[{ desc_left : courtyardsArr.courtyards_desc_left, desc_right: courtyardsArr.courtyards_desc_right}]"></sectionDescColumn>
            <sectionImagesMobile :options="[{ images: courtyardsArr.courtyards_images_mobile}]" v-if="isMobileGlobal"></sectionImagesMobile>
            <sectionImagesGrid :options="[{ cards: courtyardsArr.courtyards_cards.slice(0, 3), grid_img : courtyardsArr.courtyards_img}]" class="section-images-courtyards"></sectionImagesGrid>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import sectionImagesGrid from '@/components/partials/section-images-grid.vue'
    import sectionImagesMobile from '@/components/partials/section-images-mobile.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'courtyards-section',
        data () {
            return {
            }
        },
        computed: mapGetters({
            courtyardsArr: 'loadCourtyardsArr',
            isMobileGlobal: 'loadisMobileGlobal',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            sectionDescColumn,
            sectionImagesGrid,
            sectionImagesMobile,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/courtyards/courtyards-section.scss';
    @import '@/styles/components/courtyards/courtyards-section-respond.scss';
</style>